import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import Spacing from 'components/Spacing';

import FeesOverview from './FeesOverview';
import ApproveManagementFeesSummary from './ApproveManagementFeesSummary';
import { useState } from 'react';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay } from 'further-ui/utils';
import { LpFeeCommitmentStatus } from 'further-types/lp/lp-fee-template';
import { FundingSource } from 'further-types/lp/investment';
import { TransactionOperation } from 'further-types/lp/transaction';
import { ActionTransactionSubType } from 'further-types/lp/action';
import { ListLpFeesCategory } from 'further-types/lp/lp-fee';

type FullFeeData = {
  _id: string;
  feeActionId?: string;
  limitedPartner: string;
  disableUnapprove?: boolean;
  feeActionCreatedAt: CalendarDay;
  accrualDate: CalendarDay;
  lpFeeTemplateName: string;
  lpFeeTemplateFeeName: string;
  insideOutsideCommitment: LpFeeCommitmentStatus;
  feeExTaxLcy: number;
  salesTaxAmountLcy: number;
  feeIncTaxLcy: number;
  generalCapital: number;
  fundingSource: FundingSource;
  isFromEqualisation?: boolean;
};

type Transaction = {
  transactionTypeId: string;
  amountIncVatTcy: number;
  amountExVatTcy: number;
  operationType: TransactionOperation;
  transactionSubType: ActionTransactionSubType;
  transactionCurrency: CurrencyCode;
};

type DefaultTransactions = {
  insideCommitment: Array<Transaction>;
  outsideCommitment: Array<Transaction>;
};

export type ApprovalSummaryData = {
  date: string;
  fullFeeData: Array<FullFeeData>;
  defaultTransactions: DefaultTransactions;
  feeType: ListLpFeesCategory | undefined;
};

const FeeManager: React.FC = () => {
  const [approvalSummaryData, setApprovalSummaryData] =
    useState<ApprovalSummaryData>({
      date: '',
      fullFeeData: [],
      defaultTransactions: {
        insideCommitment: [],
        outsideCommitment: [],
      },
      feeType: undefined,
    });

  return (
    <PageContainer heading="Fee Manager">
      <PageContent>
        <Spacing>
          {!approvalSummaryData.fullFeeData.length ? (
            <FeesOverview setApprovalSummaryData={setApprovalSummaryData} />
          ) : (
            <ApproveManagementFeesSummary
              approvalSummaryData={approvalSummaryData}
              setApprovalSummaryData={setApprovalSummaryData}
            />
          )}
        </Spacing>
      </PageContent>
    </PageContainer>
  );
};

export default FeeManager;
